import StaffList from "../staffList/StaffList"

function Staff() {
    return (
        <>
            <StaffList />
        </>
    )
}
export default Staff